module.exports = Em.Component.extend({
    layoutName: 'components/upgrade-subscription-modal',

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization')
})
